import React from 'react';

const Title = () => {
    return (
        <div id="title">
            <h1>The Art Collector</h1>
            <h5>Search the Harvard Art Museums' Private Collections</h5>
        </div>
    )
}
export default Title;